export const uiClasses = {
  pageShell: 'lc-page-shell',
  pageContainer: 'lc-page-container',
  surface: 'lc-surface',
  label: 'lc-label',
  input: 'lc-input',
  select: 'lc-select',
  textarea: 'lc-textarea',
  linkButton: 'lc-link-btn',
  button: {
    primary: 'lc-btn lc-btn-primary',
    secondary: 'lc-btn lc-btn-secondary',
    outline: 'lc-btn lc-btn-outline',
    danger: 'lc-btn lc-btn-danger',
  },
  badge: {
    base: 'lc-badge',
    draft: 'lc-badge-draft',
    private: 'lc-badge-private',
    published: 'lc-badge-published',
    primary: 'lc-badge-primary',
    success: 'lc-badge-success',
    danger: 'lc-badge-danger',
  },
} as const;
